import { h } from 'vue';

const MaterialSymbolsIcon = (props) => {
  let targetIcon = props.icon;
  // Check if props.icon contains "no-fill"
  const hasNoFill = props.icon.includes(' no-fill');
  const styles = { };
  if (hasNoFill) {
    styles['--ms-icon-fill'] = 0;
    // Remove " no-fill" from the icon name
    targetIcon = targetIcon.replace(' no-fill', '');
  }

  return h(
    'i',
    {
      class: props.baseClass,
      style: styles,
    },
    targetIcon,
  );
};
MaterialSymbolsIcon.props = {
  /**
   * Base class to apply to the icon.
   */
  baseClass: {
    type: String,
    default: 'material-symbols-rounded',
  },
  /**
   * Icon to display from Material Symbols.
   */
  icon: {
    type: String,
    required: true,
  },
};

export default MaterialSymbolsIcon;
